var _defs, _rect, _polygon, _polygon2, _rect2, _path, _path2, _rect3, _rect4, _circle, _circle2, _path3, _circle3, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line10, _line11, _line12;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCommunicationSatellite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Satellite",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 303.62 168.44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".communication-station-satellite-cls-1{fill:url(#linear-gradient);}.communication-station-satellite-cls-2{fill:url(#linear-gradient-2);}.communication-station-satellite-cls-3{fill:url(#linear-gradient-3);}.communication-station-satellite-cls-4{fill:url(#linear-gradient-4);}.communication-station-satellite-cls-5{fill:url(#linear-gradient-5);}.communication-station-satellite-cls-6{fill:#6b6b6b;}.communication-station-satellite-cls-12,.communication-station-satellite-cls-13,.communication-station-satellite-cls-14,.communication-station-satellite-cls-15,.communication-station-satellite-cls-16,.communication-station-satellite-cls-17,.communication-station-satellite-cls-18,.communication-station-satellite-cls-19,.communication-station-satellite-cls-20,.communication-station-satellite-cls-21,.communication-station-satellite-cls-22,.communication-station-satellite-cls-23,.communication-station-satellite-cls-24,.communication-station-satellite-cls-7,.communication-station-satellite-cls-8,.communication-station-satellite-cls-9{stroke-miterlimit:10;}.communication-station-satellite-cls-7{fill:url(#linear-gradient-6);stroke:url(#linear-gradient-7);}.communication-station-satellite-cls-8{fill:url(#linear-gradient-8);stroke:url(#linear-gradient-9);}.communication-station-satellite-cls-9{fill:#95effd;stroke:url(#linear-gradient-10);}.communication-station-satellite-cls-10{fill:#39fdc1;}.communication-station-satellite-cls-11{fill:url(#linear-gradient-11);}.communication-station-satellite-cls-12{fill:#ff6552;stroke:url(#linear-gradient-12);}.communication-station-satellite-cls-13{fill:url(#linear-gradient-13);stroke:url(#linear-gradient-14);}.communication-station-satellite-cls-14{fill:url(#linear-gradient-15);stroke:url(#linear-gradient-16);}.communication-station-satellite-cls-15{fill:url(#linear-gradient-17);stroke:url(#linear-gradient-18);}.communication-station-satellite-cls-16{fill:url(#linear-gradient-19);stroke:url(#linear-gradient-20);}.communication-station-satellite-cls-17{fill:url(#linear-gradient-21);stroke:url(#linear-gradient-22);}.communication-station-satellite-cls-18{fill:url(#linear-gradient-23);stroke:url(#linear-gradient-24);}.communication-station-satellite-cls-19{fill:url(#linear-gradient-25);stroke:url(#linear-gradient-26);}.communication-station-satellite-cls-20{fill:url(#linear-gradient-27);stroke:url(#linear-gradient-28);}.communication-station-satellite-cls-21,.communication-station-satellite-cls-22,.communication-station-satellite-cls-23,.communication-station-satellite-cls-24{stroke:#9e9e9e;stroke-linecap:round;}.communication-station-satellite-cls-21{fill:url(#linear-gradient-29);}.communication-station-satellite-cls-22,.communication-station-satellite-cls-23{stroke-width:4px;}.communication-station-satellite-cls-22{fill:url(#linear-gradient-30);}.communication-station-satellite-cls-23{fill:url(#linear-gradient-31);}.communication-station-satellite-cls-24{fill:url(#linear-gradient-32);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 204.24,
    y1: 230.79,
    x2: 315.65,
    y2: 230.79,
    gradientTransform: "translate(112.47 -83.99) rotate(23.3)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#f6f6f6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#dedede"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#b8b6b7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#827f80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#3e3a3b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2e2a2b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 153.39,
    y1: 120.44,
    x2: 178.22,
    y2: 120.44,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 171.39,
    y1: 153.71,
    x2: 189.31,
    y2: 153.71,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 231.31,
    y1: 245.12,
    x2: 287.81,
    y2: 211.17,
    gradientTransform: "translate(109.68 -83.23) rotate(22.98)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 264.82,
    y1: 311.01,
    x2: 310.05,
    y2: 283.84,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 285.35,
    y1: 191.5,
    x2: 411.65,
    y2: 191.5,
    gradientTransform: "translate(104.15 -122.22) rotate(23.3)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#14173b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#16193d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#1d2042"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#282b4c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#393c5a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#4f526d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#6b6d83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#8b8d9e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#b1b2be"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#dadae0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#dadae0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#b1b2be"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#8b8d9e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#6b6d83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#4f526d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#393c5a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#282b4c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#1d2042"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#16193d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#14173b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 295.01,
    y1: 223.64,
    x2: 401.99,
    y2: 159.36,
    gradientTransform: "translate(104.15 -122.22) rotate(23.3)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 109.35,
    y1: 268.5,
    x2: 235.65,
    y2: 268.5,
    gradientTransform: "translate(120.26 -46.33) rotate(23.3)",
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 119.01,
    y1: 300.64,
    x2: 225.99,
    y2: 236.36,
    gradientTransform: "translate(120.26 -46.33) rotate(23.3)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 143.31,
    y1: 88.85,
    x2: 161.31,
    y2: 78.03,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 246.78,
    y1: 212.33,
    x2: 256.22,
    y2: 206.67,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 156.17,
    y1: 109.53,
    x2: 166.45,
    y2: 103.35,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 118.28,
    y1: 120.44,
    x2: 8.91,
    y2: 120.44,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#504c4d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#524e4f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#585556"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#646061"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#757172"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#8a8788"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#a5a3a3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#c4c3c3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#e8e7e7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#c8c7c7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#a3a1a1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#838181"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#686566"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#534f50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#423e3f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#373334"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#302c2d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2e2a2b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 13,
    y1: 150.83,
    x2: 114.18,
    y2: 90.04,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 294.28,
    y1: 44.46,
    x2: 185.81,
    y2: 44.46,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 189.77,
    y1: 74.66,
    x2: 290.31,
    y2: 14.26,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 72.39,
    y1: 120.79,
    x2: 55.89,
    y2: 120.79,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 61.01,
    y1: 122.67,
    x2: 67.27,
    y2: 118.91,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: 43.39,
    y1: 133.79,
    x2: 26.89,
    y2: 133.79,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: 32.01,
    y1: 135.67,
    x2: 38.27,
    y2: 131.91,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: 100.39,
    y1: 108.79,
    x2: 83.89,
    y2: 108.79,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: 89.01,
    y1: 110.67,
    x2: 95.27,
    y2: 106.91,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: 248.39,
    y1: 43.79,
    x2: 231.89,
    y2: 43.79,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    x1: 237.01,
    y1: 45.67,
    x2: 243.27,
    y2: 41.91,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-25",
    x1: 219.39,
    y1: 56.79,
    x2: 202.89,
    y2: 56.79,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-26",
    x1: 208.01,
    y1: 58.67,
    x2: 214.27,
    y2: 54.91,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-27",
    x1: 276.39,
    y1: 31.79,
    x2: 259.89,
    y2: 31.79,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-28",
    x1: 265.01,
    y1: 33.67,
    x2: 271.27,
    y2: 29.91,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-29",
    x1: 269.25,
    y1: 311.37,
    x2: 308.79,
    y2: 287.61,
    gradientTransform: "matrix(1.08, -0.04, -0.03, 1.01, -123.77, -140.19)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-30",
    x1: 243.7,
    y1: 257.76,
    x2: 283.24,
    y2: 234,
    gradientTransform: "matrix(1.25, -0.11, -0.1, 1.04, -146.86, -130.7)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-31",
    x1: 233.53,
    y1: 230.83,
    x2: 273.07,
    y2: 207.07,
    gradientTransform: "matrix(1.25, -0.11, -0.1, 1.04, -146.86, -130.7)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-32",
    x1: 271.59,
    y1: 305.25,
    x2: 311.13,
    y2: 281.5,
    gradientTransform: "matrix(0.94, 0.02, 0.03, 0.99, -104.46, -148.46)",
    xlinkHref: "#linear-gradient"
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Satellite Communications") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "communication-station-satellite-cls-1",
    x: 200.44,
    y: 228.11,
    width: 119,
    height: 5.36,
    transform: "translate(-178.77 -25.94) rotate(-23.3)"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "communication-station-satellite-cls-2",
    points: "173.95 143.89 153.39 100.52 161.67 96.98 178.22 142.35 173.95 143.89"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "communication-station-satellite-cls-3",
    points: "186.31 168.44 171.39 142.52 179.67 138.98 189.31 167.44 186.31 168.44"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "communication-station-satellite-cls-4",
    x: 231.03,
    y: 183.26,
    width: 57.06,
    height: 89.77,
    rx: 12,
    transform: "translate(-177.17 -28.11) rotate(-22.98)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "communication-station-satellite-cls-5",
    d: "M315.78,293.37l-49.1,20.74c0-.31,0-.63,0-.94A28.63,28.63,0,0,1,284,286.82a28.27,28.27,0,0,1,11.06-2.25A28.83,28.83,0,0,1,315.78,293.37Z",
    transform: "translate(-108.69 -147.56)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "communication-station-satellite-cls-6",
    d: "M219.44,206.05l52.11-22.13s-5.62-6.8-12-4.41-35,14.86-35,14.86A11.06,11.06,0,0,0,219.44,206.05Z",
    transform: "translate(-108.69 -147.56)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "communication-station-satellite-cls-7",
    x: 289,
    y: 170,
    width: 119,
    height: 43,
    transform: "translate(-156.01 5.88) rotate(-23.3)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "communication-station-satellite-cls-8",
    x: 113,
    y: 247,
    width: 119,
    height: 43,
    transform: "translate(-200.82 -57.45) rotate(-23.3)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "communication-station-satellite-cls-9",
    cx: 152.31,
    cy: 83.44,
    r: 10
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "communication-station-satellite-cls-10",
    cx: 142.81,
    cy: 61.94,
    r: 5.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "communication-station-satellite-cls-11",
    d: "M251.5,205a4.5,4.5,0,1,1-4.5,4.5,4.51,4.51,0,0,1,4.5-4.5m0-1a5.5,5.5,0,1,0,5.5,5.5,5.5,5.5,0,0,0-5.5-5.5Z",
    transform: "translate(-108.69 -147.56)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "communication-station-satellite-cls-12",
    cx: 161.31,
    cy: 106.44,
    r: 5.5
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "communication-station-satellite-cls-13",
    x1: 8.91,
    y1: 143.89,
    x2: 118.28,
    y2: 96.98
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "communication-station-satellite-cls-14",
    x1: 185.81,
    y1: 67.94,
    x2: 294.28,
    y2: 20.98
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "communication-station-satellite-cls-15",
    x1: 72.39,
    y1: 140.65,
    x2: 55.89,
    y2: 100.94
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "communication-station-satellite-cls-16",
    x1: 43.39,
    y1: 153.65,
    x2: 26.89,
    y2: 113.94
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "communication-station-satellite-cls-17",
    x1: 100.39,
    y1: 128.65,
    x2: 83.89,
    y2: 88.94
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "communication-station-satellite-cls-18",
    x1: 248.39,
    y1: 63.65,
    x2: 231.89,
    y2: 23.94
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    className: "communication-station-satellite-cls-19",
    x1: 219.39,
    y1: 76.65,
    x2: 202.89,
    y2: 36.94
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    className: "communication-station-satellite-cls-20",
    x1: 276.39,
    y1: 51.65,
    x2: 259.89,
    y2: 11.94
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    className: "communication-station-satellite-cls-21",
    x1: 156.81,
    y1: 161.94,
    x2: 203.81,
    y2: 141.94
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    className: "communication-station-satellite-cls-22",
    x1: 129.81,
    y1: 108.94,
    x2: 185.31,
    y2: 85.44
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    className: "communication-station-satellite-cls-23",
    x1: 119.81,
    y1: 81.94,
    x2: 175.31,
    y2: 58.44
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    className: "communication-station-satellite-cls-24",
    x1: 158.81,
    y1: 155.94,
    x2: 198.81,
    y2: 138.94
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommunicationSatellite);
export default __webpack_public_path__ + "static/media/communicationSatellite.3eb2f1e157acb3611e21c0c2b186469c.svg";
export { ForwardRef as ReactComponent };